import script from "./inquireListTab.vue?vue&type=script&setup=true&name=inquireListTab&lang=js"
export * from "./inquireListTab.vue?vue&type=script&setup=true&name=inquireListTab&lang=js"

const __exports__ = script;

export default __exports__